import {
  useGetProspectAccountsQuery,
  useGetProspectPartialOrdersQuery,
  useGetProspectPartialShoppersQuery,
  useGetProspectShoppersQuery,
} from "@apis/prospects/useProspects"
import { DataTable } from "@components/DataTable/DataTable"
import { Card, CardHeader, CardTitle, CardContent } from "@components/ui/card"
import { prospectAccountsColumns } from "./utils/tableCoumnsSchema"
import { ProspectShopper } from "./ProspectShopper"
import { ProspectPartialShopper } from "./ProspectPartialShopper"
import { ProspectPartialOrder } from "./ProspectPartialOrder"
import { Skeleton } from "@components/ui/skeleton"

type TProspectCenterSectionProps = {
  prospect_guid: string
}

export const ProspectCenterSection = ({
  prospect_guid,
}: TProspectCenterSectionProps) => {
  const getProspectAccountsQuery = useGetProspectAccountsQuery(prospect_guid)
  const getProspectShoppersQuery = useGetProspectShoppersQuery(prospect_guid)
  const getProspectPartialShoppersQuery =
    useGetProspectPartialShoppersQuery(prospect_guid)
  const getProspectPartialOrdersQuery =
    useGetProspectPartialOrdersQuery(prospect_guid)

  return (
    <div className="tw:grid tw:grid-cols-12 tw:gap-x-2 tw:gap-y-4">
      <Card className="tw:col-span-12">
        <CardHeader>
          <CardTitle className="tw:text-lg tw:font-bold">Accounts</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            pending={getProspectAccountsQuery.isPending}
            columns={prospectAccountsColumns(prospect_guid)}
            data={getProspectAccountsQuery.data ?? []}
          ></DataTable>
        </CardContent>
      </Card>

      <Card className="tw:col-span-12 tw:md:col-span-4">
        <CardHeader>
          <CardTitle className="tw:text-lg tw:font-bold">
            Shoppers & Offer Codes
          </CardTitle>
        </CardHeader>
        <CardContent className="tw:flex tw:flex-col tw:gap-1">
          {getProspectShoppersQuery.isPending
            ? Array(4).fill(<Skeleton className="tw:h-20 tw:rounded-md" />)
            : getProspectShoppersQuery.data?.map((prospectShopper) => (
                <ProspectShopper
                  key={prospectShopper.shopper_guid}
                  prospectShopper={prospectShopper}
                />
              ))}
        </CardContent>
      </Card>
      <Card className="tw:col-span-12 tw:md:col-span-4">
        <CardHeader>
          <CardTitle className="tw:text-lg tw:font-bold">
            Partials & Incomplete Orders
          </CardTitle>
        </CardHeader>
        <CardContent className="tw:flex tw:flex-col tw:gap-1">
          {getProspectPartialShoppersQuery.isPending
            ? Array(8).fill(<Skeleton className="tw:h-10 tw:rounded-md" />)
            : getProspectPartialShoppersQuery.data?.map(
                (prospectPartialShopper) => (
                  <ProspectPartialShopper
                    key={prospectPartialShopper.shopper_guid}
                    prospectPartialShopper={prospectPartialShopper}
                    prospect_guid={prospect_guid}
                  />
                ),
              )}
        </CardContent>
      </Card>
      <Card className="tw:col-span-12 tw:md:col-span-4">
        <CardHeader>
          <CardTitle className="tw:text-lg tw:font-bold">Orders</CardTitle>
        </CardHeader>
        <CardContent className="tw:flex tw:flex-col tw:gap-1">
          {getProspectPartialOrdersQuery.isPending
            ? Array(4).fill(<Skeleton className="tw:h-20 tw:rounded-md" />)
            : getProspectPartialOrdersQuery.data?.map(
                (prospectPartialOrder) => (
                  <ProspectPartialOrder
                    key={prospectPartialOrder.order_id}
                    prospectPartialOrder={prospectPartialOrder}
                    prospect_guid={prospect_guid}
                  />
                ),
              )}
        </CardContent>
      </Card>
    </div>
  )
}
